// // // // // // // // // // // import React from 'react';
// // // // // // // // // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // // // // // // // // import { removeToken } from '../../utils/auth';
// // // // // // // // // // // import './Sidebar.css';

// // // // // // // // // // // const Sidebar = () => {
// // // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // // //   const location = useLocation();

// // // // // // // // // // //   const handleLogout = () => {
// // // // // // // // // // //     removeToken();
// // // // // // // // // // //     navigate('/login');
// // // // // // // // // // //   };

// // // // // // // // // // //   // Helper to check active route
// // // // // // // // // // //   const isActive = (path) => location.pathname === path;

// // // // // // // // // // //   return (
// // // // // // // // // // //     <aside className="sidebar">
// // // // // // // // // // //       {/* --- HEADER --- */}
// // // // // // // // // // //       <div className="sidebar-header">
// // // // // // // // // // //         <div className="sidebar-logo-icon">
// // // // // // // // // // //            {/* SVG Icon */}
// // // // // // // // // // //            <svg className="svg-icon-large" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // // // // // // // //              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // // // // // // //              <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // // // // // // //              <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // // // // // // //            </svg>
// // // // // // // // // // //         </div>
// // // // // // // // // // //         <span className="logo-text">Administrator</span>
// // // // // // // // // // //       </div>

// // // // // // // // // // //       {/* --- SCROLLABLE MENU --- */}
// // // // // // // // // // //       <div className="sidebar-menu">

// // // // // // // // // // //         {/* Group 1: General */}
// // // // // // // // // // //         <div className="menu-group">

// // // // // // // // // // //           <div className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //               <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             Dashboard
// // // // // // // // // // //           </div>

// // // // // // // // // // //           <div className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //               <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             Apps Analytics
// // // // // // // // // // //           </div>

// // // // // // // // // // //           <div className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //               <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             Manage App
// // // // // // // // // // //           </div>

// // // // // // // // // // //         </div>

// // // // // // // // // // //         {/* Group 2: User Management Header */}
// // // // // // // // // // //         <div className="menu-section-label">User Management</div>

// // // // // // // // // // //         <div className="menu-group">

// // // // // // // // // // //           {/* User List */}
// // // // // // // // // // //           <div className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //               <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             User
// // // // // // // // // // //           </div>

// // // // // // // // // // //           {/* Student List */}
// // // // // // // // // // //           <div className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //                <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             Student 
// // // // // // // // // // //             <span className="arrow-right">›</span>
// // // // // // // // // // //           </div>
// // // // // // // // // // //             {/* --- NEW SPONSOR LIST ITEM --- */}
// // // // // // // // // // //           <div className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //               <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// // // // // // // // // // //                 <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
// // // // // // // // // // //                 <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
// // // // // // // // // // //               </svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             Sponsors 
// // // // // // // // // // //           </div>
// // // // // // // // // // //            {/* --- UPDATED: New Link and Section --- */}
// // // // // // // // // // //           <div className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // // // // // // // // //             <span className="icon"><svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // // // // // // // // //             School Information
// // // // // // // // // // //           </div>

// // // // // // // // // // //         </div>


// // // // // // // // // // //         {/* Group 3: Bottom Items */}
// // // // // // // // // // //         <div className="menu-group bottom-group">

// // // // // // // // // // //           <div className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //                 <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             Settings
// // // // // // // // // // //           </div>

// // // // // // // // // // //           <div className="menu-item" onClick={handleLogout}>
// // // // // // // // // // //             <span className="icon">
// // // // // // // // // // //               <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
// // // // // // // // // // //             </span>
// // // // // // // // // // //             Log out
// // // // // // // // // // //           </div>

// // // // // // // // // // //         </div>

// // // // // // // // // // //       </div>
// // // // // // // // // // //     </aside>
// // // // // // // // // // //   );
// // // // // // // // // // // };

// // // // // // // // // // // export default Sidebar;


// // // // // // // // // // import React, { useState, useEffect } from 'react';
// // // // // // // // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // // // // // // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // // // // // // // // import './Sidebar.css';

// // // // // // // // // // const Sidebar = () => {
// // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // //   const location = useLocation();

// // // // // // // // // //   const [userProfile, setUserProfile] = useState({
// // // // // // // // // //     name: 'Loading...',
// // // // // // // // // //     role: '',
// // // // // // // // // //     avatar: null
// // // // // // // // // //   });

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     const loadData = async () => {
// // // // // // // // // //       const decoded = getDecodedToken();
// // // // // // // // // //       if (!decoded || !decoded.userId) {
// // // // // // // // // //         navigate('/login');
// // // // // // // // // //         return;
// // // // // // // // // //       }

// // // // // // // // // //       let profileData = {
// // // // // // // // // //         name: 'User',
// // // // // // // // // //         role: decoded.role || 'Admin',
// // // // // // // // // //         avatar: null
// // // // // // // // // //       };

// // // // // // // // // //       try {
// // // // // // // // // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // // // // // // // // //         if (response.ok) {
// // // // // // // // // //           const data = await response.json();
// // // // // // // // // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // // // // // // // // //           profileData.name = fullName || 'User';
// // // // // // // // // //           profileData.role = data.role || decoded.role;
// // // // // // // // // //           profileData.avatar = data.photo_url || null;
// // // // // // // // // //         } else {
// // // // // // // // // //            console.warn("Failed to fetch user details from API. Using fallback data.");
// // // // // // // // // //         }
// // // // // // // // // //       } catch (error) {
// // // // // // // // // //         console.error("Failed to fetch user details from API", error);
// // // // // // // // // //       }

// // // // // // // // // //       if (!profileData.avatar) {
// // // // // // // // // //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// // // // // // // // // //       }

// // // // // // // // // //       setUserProfile(profileData);
// // // // // // // // // //     };

// // // // // // // // // //     loadData();
// // // // // // // // // //   }, [navigate]);

// // // // // // // // // //   const handleLogout = () => {
// // // // // // // // // //     removeToken();
// // // // // // // // // //     navigate('/login');
// // // // // // // // // //   };

// // // // // // // // // //   const isActive = (path) => location.pathname === path;

// // // // // // // // // //   return (
// // // // // // // // // //     <aside className="sidebar">
// // // // // // // // // //       <div className="sidebar-header">
// // // // // // // // // //         <div className="sidebar-logo-icon">
// // // // // // // // // //            <svg className="svg-icon-large" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// // // // // // // // // //              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // // // // // //              <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // // // // // //              <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
// // // // // // // // // //            </svg>
// // // // // // // // // //         </div>
// // // // // // // // // //         <span className="logo-text">Administrator</span>
// // // // // // // // // //       </div>

// // // // // // // // // //       <div className="sidebar-menu">
// // // // // // // // // //         <div className="menu-group">
// // // // // // // // // //           <div className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // // // // // // // // //             Dashboard
// // // // // // // // // //           </div>
// // // // // // // // // //           <div className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // // // // // // // // //             Apps Analytics
// // // // // // // // // //           </div>
// // // // // // // // // //           <div className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // // // // //             Manage App
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>

// // // // // // // // // //         <div className="menu-section-label">User Management</div>
// // // // // // // // // //         <div className="menu-group">
// // // // // // // // // //           <div className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></span>
// // // // // // // // // //             User
// // // // // // // // // //           </div>
// // // // // // // // // //           <div className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // // // // // // // //             Student 
// // // // // // // // // //             <span className="arrow-right">›</span>
// // // // // // // // // //           </div>
// // // // // // // // // //           <div className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // // // // // // // // //             Sponsors 
// // // // // // // // // //           </div>
// // // // // // // // // //           <div className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // // // // // // // //             <span className="icon"><svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // // // // // // // //             School Information
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>

// // // // // // // // // //         <div className="menu-group bottom-group">
// // // // // // // // // //           <div className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // // // // //             Settings
// // // // // // // // // //           </div>

// // // // // // // // // //           <div className="sidebar-profile" onClick={() => handleNavigation('/settings')} title="View Profile">
// // // // // // // // // //             {userProfile.avatar && (
// // // // // // // // // //               <img 
// // // // // // // // // //                 src={userProfile.avatar} 
// // // // // // // // // //                 alt="Profile" 
// // // // // // // // // //                 className="sidebar-profile-img" 
// // // // // // // // // //               />
// // // // // // // // // //             )}
// // // // // // // // // //             <div className="sidebar-profile-info">
// // // // // // // // // //               <span className="sidebar-profile-name">{userProfile.name}</span>
// // // // // // // // // //               <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // // // // // // // // //             </div>
// // // // // // // // // //           </div>

// // // // // // // // // //           <div className="menu-item" onClick={handleLogout}>
// // // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // // // // // // // // //             Log out
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>
// // // // // // // // // //       </div>
// // // // // // // // // //     </aside>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default Sidebar;


// // // // // // // // // import React, { useState, useEffect } from 'react';
// // // // // // // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // // // // // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // // // // // // // import './Sidebar.css';
// // // // // // // // // import logo from '../../assets/trustchildlogo.png';

// // // // // // // // // // CRITICAL: Component now accepts props for collapse state and the toggle function
// // // // // // // // // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// // // // // // // // //   const navigate = useNavigate();
// // // // // // // // //   const location = useLocation();

// // // // // // // // //   const [userProfile, setUserProfile] = useState({
// // // // // // // // //     name: 'Loading...',
// // // // // // // // //     role: '',
// // // // // // // // //     avatar: null
// // // // // // // // //   });

// // // // // // // // //   useEffect(() => {
// // // // // // // // //     const loadData = async () => {
// // // // // // // // //       const decoded = getDecodedToken();
// // // // // // // // //       if (!decoded || !decoded.userId) {
// // // // // // // // //         navigate('/login');
// // // // // // // // //         return;
// // // // // // // // //       }

// // // // // // // // //       let profileData = {
// // // // // // // // //         name: 'User',
// // // // // // // // //         role: decoded.role || 'Admin',
// // // // // // // // //         avatar: null
// // // // // // // // //       };

// // // // // // // // //       try {
// // // // // // // // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // // // // // // // //         if (response.ok) {
// // // // // // // // //           const data = await response.json();
// // // // // // // // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // // // // // // // //           profileData.name = fullName || 'User';
// // // // // // // // //           profileData.role = data.role || decoded.role;
// // // // // // // // //           profileData.avatar = data.photo_url || null;
// // // // // // // // //         } else {
// // // // // // // // //            console.warn("Failed to fetch user details from API. Using fallback data.");
// // // // // // // // //         }
// // // // // // // // //       } catch (error) {
// // // // // // // // //         console.error("Failed to fetch user details from API", error);
// // // // // // // // //       }

// // // // // // // // //       if (!profileData.avatar) {
// // // // // // // // //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// // // // // // // // //       }

// // // // // // // // //       setUserProfile(profileData);
// // // // // // // // //     };

// // // // // // // // //     loadData();
// // // // // // // // //   }, [navigate]);

// // // // // // // // //   const handleLogout = () => {
// // // // // // // // //     removeToken();
// // // // // // // // //     navigate('/login');
// // // // // // // // //   };

// // // // // // // // //   const isActive = (path) => location.pathname === path;

// // // // // // // // //   // CRITICAL: The 'collapsed' class is dynamically added here
// // // // // // // // //   return (
// // // // // // // // //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// // // // // // // // //       <div className="sidebar-header">
// // // // // // // // //         {/* This container holds the logo and text */}
// // // // // // // // //         <div className="logo-container">
// // // // // // // // //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// // // // // // // // //           <span className="sidebar-logo-text">Trust Children</span>
// // // // // // // // //         </div>
// // // // // // // // //         {/* --- NEW: THE TOGGLE BUTTON --- */}
// // // // // // // // //         <button className="sidebar-toggle" onClick={toggleCollapse}>
// // // // // // // // //           <svg viewBox="0 0 24 24">
// // // // // // // // //             <path d="M15 18l-6-6 6-6"/>
// // // // // // // // //           </svg>
// // // // // // // // //         </button>
// // // // // // // // //       </div>

// // // // // // // // //       <div className="sidebar-menu">
// // // // // // // // //         <div className="menu-group">
// // // // // // // // //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // // // // // // // //             <span className="menu-text">Dashboard</span>
// // // // // // // // //           </div>
// // // // // // // // //           <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // // // // // // // //             <span className="menu-text">Apps Analytics</span>
// // // // // // // // //           </div>
// // // // // // // // //           <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // // // //             <span className="menu-text">Manage App</span>
// // // // // // // // //           </div>
// // // // // // // // //         </div>

// // // // // // // // //         <div className="menu-section-label">User Management</div>
// // // // // // // // //         <div className="menu-group">
// // // // // // // // //           <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></span>
// // // // // // // // //             <span className="menu-text">User</span>
// // // // // // // // //           </div>
// // // // // // // // //           <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // // // // // // //             <span className="menu-text">Student</span>
// // // // // // // // //             <span className="arrow-right">›</span>
// // // // // // // // //           </div>
// // // // // // // // //           <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // // // // // // // //             <span className="menu-text">Sponsors</span>
// // // // // // // // //           </div>
// // // // // // // // //           <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // // // // // // //             <span className="menu-text">School Information</span>
// // // // // // // // //           </div>
// // // // // // // // //         </div>

// // // // // // // // //         <div className="menu-group bottom-group">
// // // // // // // // //           <div title="Settings" className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // // // //             <span className="menu-text">Settings</span>
// // // // // // // // //           </div>

// // // // // // // // //           <div className="sidebar-profile" onClick={() => handleNavigation('/settings')} title="View Profile">
// // // // // // // // //             {userProfile.avatar && (
// // // // // // // // //               <img 
// // // // // // // // //                 src={userProfile.avatar} 
// // // // // // // // //                 alt="Profile" 
// // // // // // // // //                 className="sidebar-profile-img" 
// // // // // // // // //               />
// // // // // // // // //             )}
// // // // // // // // //             <div className="sidebar-profile-info">
// // // // // // // // //               <span className="sidebar-profile-name">{userProfile.name}</span>
// // // // // // // // //               <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // // // // // // // //             </div>
// // // // // // // // //           </div>

// // // // // // // // //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// // // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // // // // // // // //             <span className="menu-text">Log out</span>
// // // // // // // // //           </div>
// // // // // // // // //         </div>
// // // // // // // // //       </div>
// // // // // // // // //     </aside>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default Sidebar;


// // // // // // // // import React, { useState, useEffect } from 'react';
// // // // // // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // // // // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // // // // // // import './Sidebar.css';
// // // // // // // // import logo from '../../assets/trustchildlogo.png';

// // // // // // // // // CRITICAL: Component now accepts props for collapse state and the toggle function
// // // // // // // // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// // // // // // // //   const navigate = useNavigate();
// // // // // // // //   const location = useLocation();

// // // // // // // //   const [userProfile, setUserProfile] = useState({
// // // // // // // //     name: 'Loading...',
// // // // // // // //     role: '',
// // // // // // // //     avatar: null
// // // // // // // //   });

// // // // // // // //   useEffect(() => {
// // // // // // // //     const loadData = async () => {
// // // // // // // //       const decoded = getDecodedToken();
// // // // // // // //       if (!decoded || !decoded.userId) {
// // // // // // // //         navigate('/login');
// // // // // // // //         return;
// // // // // // // //       }

// // // // // // // //       let profileData = {
// // // // // // // //         name: 'User',
// // // // // // // //         role: decoded.role || 'Admin',
// // // // // // // //         avatar: null
// // // // // // // //       };

// // // // // // // //       try {
// // // // // // // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // // // // // // //         if (response.ok) {
// // // // // // // //           const data = await response.json();
// // // // // // // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // // // // // // //           profileData.name = fullName || 'User';
// // // // // // // //           profileData.role = data.role || decoded.role;
// // // // // // // //           profileData.avatar = data.photo_url || null;
// // // // // // // //         } else {
// // // // // // // //            console.warn("Failed to fetch user details from API. Using fallback data.");
// // // // // // // //         }
// // // // // // // //       } catch (error) {
// // // // // // // //         console.error("Failed to fetch user details from API", error);
// // // // // // // //       }

// // // // // // // //       if (!profileData.avatar) {
// // // // // // // //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// // // // // // // //       }

// // // // // // // //       setUserProfile(profileData);
// // // // // // // //     };

// // // // // // // //     loadData();
// // // // // // // //   }, [navigate]);

// // // // // // // //   const handleLogout = () => {
// // // // // // // //     removeToken();
// // // // // // // //     navigate('/login');
// // // // // // // //   };

// // // // // // // //   const isActive = (path) => location.pathname === path;

// // // // // // // //   // CRITICAL: The 'collapsed' class is dynamically added here
// // // // // // // //   return (
// // // // // // // //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// // // // // // // //       <div className="sidebar-header">
// // // // // // // //         {/* This container holds the logo and text */}
// // // // // // // //         <div className="logo-container">
// // // // // // // //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// // // // // // // //           <span className="sidebar-logo-text">Trust Children</span>
// // // // // // // //         </div>
// // // // // // // //         {/* --- NEW: THE TOGGLE BUTTON --- */}
// // // // // // // //         <button className="sidebar-toggle" onClick={toggleCollapse}>
// // // // // // // //           <svg viewBox="0 0 24 24">
// // // // // // // //             <path d="M15 18l-6-6 6-6"/>
// // // // // // // //           </svg>
// // // // // // // //         </button>
// // // // // // // //       </div>

// // // // // // // //       <div className="sidebar-menu">
// // // // // // // //         <div className="menu-group">
// // // // // // // //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // // // // // // //             <span className="menu-text">Dashboard</span>
// // // // // // // //           </div>
// // // // // // // //           <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // // // // // // //             <span className="menu-text">Apps Analytics</span>
// // // // // // // //           </div>
// // // // // // // //           <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // // //             <span className="menu-text">Manage App</span>
// // // // // // // //           </div>
// // // // // // // //         </div>

// // // // // // // //         <div className="menu-section-label">User Management</div>
// // // // // // // //         <div className="menu-group">
// // // // // // // //           <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></span>
// // // // // // // //             <span className="menu-text">User</span>
// // // // // // // //           </div>
// // // // // // // //           <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // // // // // //             <span className="menu-text">Student</span>
// // // // // // // //             <span className="arrow-right">›</span>
// // // // // // // //           </div>
// // // // // // // //           {/* --- ADDED TEACHER LINK --- */}
// // // // // // // //           <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
// // // // // // // //             <span className="menu-text">Teacher</span>
// // // // // // // //           </div>
// // // // // // // //           <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // // // // // // //             <span className="menu-text">Sponsors</span>
// // // // // // // //           </div>
// // // // // // // //           <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // // // // // //             <span className="menu-text">School Information</span>
// // // // // // // //           </div>
// // // // // // // //         </div>

// // // // // // // //         <div className="menu-group bottom-group">
// // // // // // // //           <div title="Settings" className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // // //             <span className="menu-text">Settings</span>
// // // // // // // //           </div>

// // // // // // // //           <div className="sidebar-profile" onClick={() => handleNavigation('/settings')} title="View Profile">
// // // // // // // //             {userProfile.avatar && (
// // // // // // // //               <img 
// // // // // // // //                 src={userProfile.avatar} 
// // // // // // // //                 alt="Profile" 
// // // // // // // //                 className="sidebar-profile-img" 
// // // // // // // //               />
// // // // // // // //             )}
// // // // // // // //             <div className="sidebar-profile-info">
// // // // // // // //               <span className="sidebar-profile-name">{userProfile.name}</span>
// // // // // // // //               <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // // // // // // //             </div>
// // // // // // // //           </div>

// // // // // // // //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// // // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // // // // // // //             <span className="menu-text">Log out</span>
// // // // // // // //           </div>
// // // // // // // //         </div>
// // // // // // // //       </div>
// // // // // // // //     </aside>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default Sidebar;

// // // // // // // import React, { useState, useEffect } from 'react';
// // // // // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // // // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // // // // // import './Sidebar.css';
// // // // // // // import logo from '../../assets/trustchildlogo.png';

// // // // // // // // CRITICAL: Component now accepts props for collapse state and the toggle function
// // // // // // // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// // // // // // //   const navigate = useNavigate();
// // // // // // //   const location = useLocation();

// // // // // // //   const [userProfile, setUserProfile] = useState({
// // // // // // //     name: 'Loading...',
// // // // // // //     role: '',
// // // // // // //     avatar: null
// // // // // // //   });

// // // // // // //   useEffect(() => {
// // // // // // //     const loadData = async () => {
// // // // // // //       const decoded = getDecodedToken();
// // // // // // //       if (!decoded || !decoded.userId) {
// // // // // // //         navigate('/login');
// // // // // // //         return;
// // // // // // //       }

// // // // // // //       let profileData = {
// // // // // // //         name: 'User',
// // // // // // //         role: decoded.role || 'Admin',
// // // // // // //         avatar: null
// // // // // // //       };

// // // // // // //       try {
// // // // // // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // // // // // //         if (response.ok) {
// // // // // // //           const data = await response.json();
// // // // // // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // // // // // //           profileData.name = fullName || 'User';
// // // // // // //           profileData.role = data.role || decoded.role;
// // // // // // //           profileData.avatar = data.photo_url || null;
// // // // // // //         } else {
// // // // // // //            console.warn("Failed to fetch user details from API. Using fallback data.");
// // // // // // //         }
// // // // // // //       } catch (error) {
// // // // // // //         console.error("Failed to fetch user details from API", error);
// // // // // // //       }

// // // // // // //       if (!profileData.avatar) {
// // // // // // //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// // // // // // //       }

// // // // // // //       setUserProfile(profileData);
// // // // // // //     };

// // // // // // //     loadData();
// // // // // // //   }, [navigate]);

// // // // // // //   const handleLogout = () => {
// // // // // // //     removeToken();
// // // // // // //     navigate('/login');
// // // // // // //   };

// // // // // // //   const isActive = (path) => location.pathname === path;

// // // // // // //   // CRITICAL: The 'collapsed' class is dynamically added here
// // // // // // //   return (
// // // // // // //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// // // // // // //       <div className="sidebar-header">
// // // // // // //         {/* This container holds the logo and text */}
// // // // // // //         <div className="logo-container">
// // // // // // //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// // // // // // //           <span className="sidebar-logo-text">Trust Children</span>
// // // // // // //         </div>
// // // // // // //         {/* --- NEW: THE TOGGLE BUTTON --- */}
// // // // // // //         <button className="sidebar-toggle" onClick={toggleCollapse}>
// // // // // // //           <svg viewBox="0 0 24 24">
// // // // // // //             <path d="M15 18l-6-6 6-6"/>
// // // // // // //           </svg>
// // // // // // //         </button>
// // // // // // //       </div>

// // // // // // //       <div className="sidebar-menu">
// // // // // // //         <div className="menu-group">
// // // // // // //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // // // // // //             <span className="menu-text">Dashboard</span>
// // // // // // //           </div>
// // // // // // //           <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // // // // // //             <span className="menu-text">Apps Analytics</span>
// // // // // // //           </div>
// // // // // // //           <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // //             <span className="menu-text">Manage App</span>
// // // // // // //           </div>
// // // // // // //         </div>

// // // // // // //         <div className="menu-section-label">User Management</div>
// // // // // // //         <div className="menu-group">
// // // // // // //           <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></span>
// // // // // // //             <span className="menu-text">User</span>
// // // // // // //           </div>
// // // // // // //           <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // // // // //             <span className="menu-text">Student</span>
// // // // // // //             <span className="arrow-right">›</span>
// // // // // // //           </div>
// // // // // // //           <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
// // // // // // //             <span className="menu-text">Teacher</span>
// // // // // // //           </div>
// // // // // // //           <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // // // // // //             <span className="menu-text">Sponsors</span>
// // // // // // //           </div>
// // // // // // //           <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // // // // //             <span className="menu-text">School Information</span>
// // // // // // //           </div>
// // // // // // //         </div>

// // // // // // //         <div className="menu-group bottom-group">
// // // // // // //           <div title="Settings" className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // // //             <span className="menu-text">Settings</span>
// // // // // // //           </div>

// // // // // // //           <div className="sidebar-profile" onClick={() => handleNavigation('/settings')} title="View Profile">
// // // // // // //             {userProfile.avatar && (
// // // // // // //               <img 
// // // // // // //                 src={userProfile.avatar} 
// // // // // // //                 alt="Profile" 
// // // // // // //                 className="sidebar-profile-img" 
// // // // // // //               />
// // // // // // //             )}
// // // // // // //             <div className="sidebar-profile-info">
// // // // // // //               <span className="sidebar-profile-name">{userProfile.name}</span>
// // // // // // //               <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // // // // // //             </div>
// // // // // // //           </div>

// // // // // // //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// // // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // // // // // //             <span className="menu-text">Log out</span>
// // // // // // //           </div>
// // // // // // //         </div>
// // // // // // //       </div>
// // // // // // //     </aside>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default Sidebar;

// // // // // // import React, { useState, useEffect } from 'react';
// // // // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // // // // import './Sidebar.css';
// // // // // // import logo from '../../assets/trustchildlogo.png';

// // // // // // // CRITICAL: Component now accepts props for collapse state and the toggle function
// // // // // // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// // // // // //   const navigate = useNavigate();
// // // // // //   const location = useLocation();

// // // // // //   const [userProfile, setUserProfile] = useState({
// // // // // //     name: 'Loading...',
// // // // // //     role: '',
// // // // // //     avatar: null
// // // // // //   });

// // // // // //   useEffect(() => {
// // // // // //     const loadData = async () => {
// // // // // //       const decoded = getDecodedToken();
// // // // // //       if (!decoded || !decoded.userId) {
// // // // // //         navigate('/login');
// // // // // //         return;
// // // // // //       }

// // // // // //       let profileData = {
// // // // // //         name: 'User',
// // // // // //         role: decoded.role || 'Admin',
// // // // // //         avatar: null
// // // // // //       };

// // // // // //       try {
// // // // // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // // // // //         if (response.ok) {
// // // // // //           const data = await response.json();
// // // // // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // // // // //           profileData.name = fullName || 'User';
// // // // // //           profileData.role = data.role || decoded.role;
// // // // // //           profileData.avatar = data.photo_url || null;
// // // // // //         } else {
// // // // // //            console.warn("Failed to fetch user details from API. Using fallback data.");
// // // // // //         }
// // // // // //       } catch (error) {
// // // // // //         console.error("Failed to fetch user details from API", error);
// // // // // //       }

// // // // // //       if (!profileData.avatar) {
// // // // // //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// // // // // //       }

// // // // // //       setUserProfile(profileData);
// // // // // //     };

// // // // // //     loadData();
// // // // // //   }, [navigate]);

// // // // // //   const handleLogout = () => {
// // // // // //     removeToken();
// // // // // //     navigate('/login');
// // // // // //   };

// // // // // //   const isActive = (path) => location.pathname === path;

// // // // // //   // CRITICAL: The 'collapsed' class is dynamically added here
// // // // // //   return (
// // // // // //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// // // // // //       <div className="sidebar-header">
// // // // // //         {/* This container holds the logo and text */}
// // // // // //         <div className="logo-container">
// // // // // //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// // // // // //           <span className="sidebar-logo-text">Trust Children</span>
// // // // // //         </div>
// // // // // //       </div>

// // // // // //       <div className="sidebar-menu">
// // // // // //         <div className="menu-group">
// // // // // //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // // // // //             <span className="menu-text">Dashboard</span>
// // // // // //           </div>
// // // // // //           <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // // // // //             <span className="menu-text">Apps Analytics</span>
// // // // // //           </div>
// // // // // //           <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // //             <span className="menu-text">Manage App</span>
// // // // // //           </div>
// // // // // //         </div>

// // // // // //         <div className="menu-section-label">User Management</div>
// // // // // //         <div className="menu-group">
// // // // // //           <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></span>
// // // // // //             <span className="menu-text">User</span>
// // // // // //           </div>
// // // // // //           <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // // // //             <span className="menu-text">Student</span>
// // // // // //             <span className="arrow-right">›</span>
// // // // // //           </div>
// // // // // //           <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
// // // // // //             <span className="menu-text">Teacher</span>
// // // // // //           </div>
// // // // // //           <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // // // // //             <span className="menu-text">Sponsors</span>
// // // // // //           </div>
// // // // // //           <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // // // //             <span className="menu-text">School Information</span>
// // // // // //           </div>
// // // // // //         </div>

// // // // // //         <div className="menu-group bottom-group">
// // // // // //           <div title="Settings" className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // // //             <span className="menu-text">Settings</span>
// // // // // //           </div>

// // // // // //           <div className="sidebar-profile" onClick={() => handleNavigation('/settings')} title="View Profile">
// // // // // //             {userProfile.avatar && (
// // // // // //               <img 
// // // // // //                 src={userProfile.avatar} 
// // // // // //                 alt="Profile" 
// // // // // //                 className="sidebar-profile-img" 
// // // // // //               />
// // // // // //             )}
// // // // // //             <div className="sidebar-profile-info">
// // // // // //               <span className="sidebar-profile-name">{userProfile.name}</span>
// // // // // //               <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// // // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // // // // //             <span className="menu-text">Log out</span>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </div>
// // // // // //     </aside>
// // // // // //   );
// // // // // // };

// // // // // // export default Sidebar;


// // // // // import React, { useState, useEffect } from 'react';
// // // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // // // import './Sidebar.css';
// // // // // import logo from '../../assets/trustchildlogo.png';

// // // // // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// // // // //   const navigate = useNavigate();
// // // // //   const location = useLocation();

// // // // //   const [userProfile, setUserProfile] = useState({
// // // // //     name: 'Loading...',
// // // // //     role: '',
// // // // //     avatar: null
// // // // //   });

// // // // //   useEffect(() => {
// // // // //     const loadData = async () => {
// // // // //       const decoded = getDecodedToken();
// // // // //       if (!decoded || !decoded.userId) {
// // // // //         navigate('/login');
// // // // //         return;
// // // // //       }

// // // // //       let profileData = {
// // // // //         name: 'User',
// // // // //         role: decoded.role || '',
// // // // //         avatar: null
// // // // //       };

// // // // //       try {
// // // // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // // // //         if (response.ok) {
// // // // //           const data = await response.json();
// // // // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // // // //           profileData.name = fullName || 'User';
// // // // //           profileData.role = data.role || decoded.role;
// // // // //           profileData.avatar = data.photo_url || null;
// // // // //         }
// // // // //       } catch (error) {
// // // // //         console.error("Failed to fetch user details from API", error);
// // // // //       }

// // // // //       if (!profileData.avatar) {
// // // // //         profileData.avatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name)}&background=1559C3&color=fff&bold=true`;
// // // // //       }

// // // // //       setUserProfile(profileData);
// // // // //     };

// // // // //     loadData();
// // // // //   }, [navigate]);

// // // // //   const handleLogout = () => {
// // // // //     removeToken();
// // // // //     navigate('/login');
// // // // //   };

// // // // //   const isActive = (path) => location.pathname === path;

// // // // //   const role = userProfile.role.toLowerCase();
// // // // //   const isSuperAdmin = role === 'super_admin';
// // // // //   const isTeacher = role === 'teacher';
// // // // //   const isStudent = role === 'student';

// // // // //   return (
// // // // //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// // // // //       <div className="sidebar-header">
// // // // //         <div className="logo-container">
// // // // //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// // // // //           <span className="sidebar-logo-text">Trust Children</span>
// // // // //         </div>
// // // // //       </div>

// // // // //       <div className="sidebar-menu">
// // // // //         <div className="menu-group">
// // // // //           {/* Dashboard: Visible to ALL */}
// // // // //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // // // //             <span className="menu-text">Dashboard</span>
// // // // //           </div>

// // // // //           {/* Super Admin Specific Items */}
// // // // //           {isSuperAdmin && (
// // // // //             <>
// // // // //               <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // // // //                 <span className="menu-text">Apps Analytics</span>
// // // // //               </div>
// // // // //               <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // //                 <span className="menu-text">Manage App</span>
// // // // //               </div>
// // // // //             </>
// // // // //           )}

// // // // //           {/* Teacher Specific Items (Marks Entry) */}
// // // // //           {isTeacher && (
// // // // //             <div title="Marks Entry" className={`menu-item ${isActive('/marks-entry') ? 'active' : ''}`} onClick={() => handleNavigation('/marks-entry')}>
// // // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg></span>
// // // // //               <span className="menu-text">Marks Entry</span>
// // // // //             </div>
// // // // //           )}

// // // // //           {/* Teacher & Student Shared Items (Attendance) */}
// // // // //           {(isTeacher || isStudent) && (
// // // // //             <div title="Attendance" className={`menu-item ${isActive('/attendance') ? 'active' : ''}`} onClick={() => handleNavigation('/attendance')}>
// // // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></span>
// // // // //               <span className="menu-text">Attendance</span>
// // // // //             </div>
// // // // //           )}

// // // // //           {/* Student Specific Items (Report Card) */}
// // // // //           {isStudent && (
// // // // //             <div title="Report Card" className={`menu-item ${isActive('/report-card') ? 'active' : ''}`} onClick={() => handleNavigation('/report-card')}>
// // // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></span>
// // // // //               <span className="menu-text">Report Card</span>
// // // // //             </div>
// // // // //           )}
// // // // //         </div>

// // // // //         {/* User Management Section: Only for Super Admin */}
// // // // //         {isSuperAdmin && (
// // // // //           <>
// // // // //             <div className="menu-section-label">User Management</div>
// // // // //             <div className="menu-group">
// // // // //               <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></span>
// // // // //                 <span className="menu-text">User</span>
// // // // //               </div>
// // // // //               <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // // //                 <span className="menu-text">Student</span>
// // // // //               </div>
// // // // //               <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
// // // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
// // // // //                 <span className="menu-text">Teacher</span>
// // // // //               </div>
// // // // //               <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // // // //                 <span className="menu-text">Sponsors</span>
// // // // //               </div>
// // // // //               <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // // //                 <span className="menu-text">School Information</span>
// // // // //               </div>
// // // // //             </div>
// // // // //           </>
// // // // //         )}

// // // // //         {/* Shared items for Teacher (Student link is visible here for teacher) */}
// // // // //         {isTeacher && (
// // // // //           <div className="menu-group">
// // // // //             <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // // //               <span className="menu-text">Student List</span>
// // // // //             </div>
// // // // //           </div>
// // // // //         )}

// // // // //         <div className="menu-group bottom-group">
// // // // //           {/* User Profile / Settings: Visible to ALL */}
// // // // //           <div title="User Profile" className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // // //             <span className="menu-text">{isSuperAdmin ? 'Settings' : 'User Profile'}</span>
// // // // //           </div>

// // // // //           <div className="sidebar-profile" onClick={() => handleNavigation('/settings')} title="View Profile">
// // // // //             {userProfile.avatar && (
// // // // //               <img 
// // // // //                 src={userProfile.avatar} 
// // // // //                 alt="Profile" 
// // // // //                 className="sidebar-profile-img" 
// // // // //               />
// // // // //             )}
// // // // //             <div className="sidebar-profile-info">
// // // // //               <span className="sidebar-profile-name">{userProfile.name}</span>
// // // // //               <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // // // //             </div>
// // // // //           </div>

// // // // //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// // // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // // // //             <span className="menu-text">Log out</span>
// // // // //           </div>
// // // // //         </div>
// // // // //       </div>
// // // // //     </aside>
// // // // //   );
// // // // // };

// // // // // export default Sidebar;


// // // // import React, { useState, useEffect } from 'react';
// // // // import { useNavigate, useLocation } from 'react-router-dom';
// // // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // // import './Sidebar.css';
// // // // import logo from '../../assets/trustchildlogo.png';

// // // // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// // // //   const navigate = useNavigate();
// // // //   const location = useLocation();

// // // //   const [userProfile, setUserProfile] = useState({
// // // //     name: 'Loading...',
// // // //     role: '',
// // // //     avatar: null
// // // //   });

// // // //   useEffect(() => {
// // // //     const loadData = async () => {
// // // //       const decoded = getDecodedToken();
// // // //       if (!decoded || !decoded.userId) {
// // // //         navigate('/login');
// // // //         return;
// // // //       }

// // // //       try {
// // // //         // Fetch fresh user details from the backend to get the latest photo_url
// // // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // // //         if (response.ok) {
// // // //           const data = await response.json();
// // // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // // //           // Construct the full URL for the profile photo
// // // //           let photo = null;
// // // //           if (data.photo_url) {
// // // //             // Prepend the backend server URL if the path is relative
// // // //             photo = data.photo_url.startsWith('http') 
// // // //               ? data.photo_url 
// // // //               : `http://localhost:3005${data.photo_url}`;
// // // //           } else {
// // // //             // Fallback: Generate a UI Avatar if no photo exists in DB
// // // //             photo = `https://ui-avatars.com/api/?name=${encodeURIComponent(fullName || 'User')}&background=1559C3&color=fff&bold=true`;
// // // //           }

// // // //           setUserProfile({
// // // //             name: fullName || 'User',
// // // //             role: data.role || decoded.role,
// // // //             avatar: photo
// // // //           });
// // // //         }
// // // //       } catch (error) {
// // // //         console.error("Sidebar profile fetch error:", error);
// // // //       }
// // // //     };

// // // //     loadData();
// // // //   }, [navigate, location.pathname]); // Reload when navigation happens to catch profile updates

// // // //   const handleLogout = () => {
// // // //     removeToken();
// // // //     navigate('/login');
// // // //   };

// // // //   const isActive = (path) => location.pathname === path;

// // // //   const role = userProfile.role.toLowerCase();
// // // //   const isSuperAdmin = role === 'super_admin';
// // // //   const isTeacher = role === 'teacher';
// // // //   const isStudent = role === 'student';

// // // //   return (
// // // //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// // // //       <div className="sidebar-header">
// // // //         <div className="logo-container">
// // // //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// // // //           {!isCollapsed && <span className="sidebar-logo-text">Trust Children</span>}
// // // //         </div>
// // // //       </div>

// // // //       <div className="sidebar-menu">
// // // //         <div className="menu-group">
// // // //           {/* Dashboard: Visible to ALL */}
// // // //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // // //             {!isCollapsed && <span className="menu-text">Dashboard</span>}
// // // //           </div>

// // // //           {/* Super Admin Specific Items */}
// // // //           {isSuperAdmin && (
// // // //             <>
// // // //               <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // // //                 {!isCollapsed && <span className="menu-text">Apps Analytics</span>}
// // // //               </div>
// // // //               <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // // //                 {!isCollapsed && <span className="menu-text">Manage App</span>}
// // // //               </div>
// // // //             </>
// // // //           )}

// // // //           {/* Teacher Specific Items */}
// // // //           {isTeacher && (
// // // //             <div title="Marks Entry" className={`menu-item ${isActive('/marks-entry') ? 'active' : ''}`} onClick={() => handleNavigation('/marks-entry')}>
// // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg></span>
// // // //               {!isCollapsed && <span className="menu-text">Marks Entry</span>}
// // // //             </div>
// // // //           )}

// // // //           {(isTeacher || isStudent) && (
// // // //             <div title="Attendance" className={`menu-item ${isActive('/attendance') ? 'active' : ''}`} onClick={() => handleNavigation('/attendance')}>
// // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></span>
// // // //               {!isCollapsed && <span className="menu-text">Attendance</span>}
// // // //             </div>
// // // //           )}

// // // //           {isStudent && (
// // // //             <div title="Report Card" className={`menu-item ${isActive('/report-card') ? 'active' : ''}`} onClick={() => handleNavigation('/report-card')}>
// // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></span>
// // // //               {!isCollapsed && <span className="menu-text">Report Card</span>}
// // // //             </div>
// // // //           )}
// // // //         </div>

// // // //         {isSuperAdmin && (
// // // //           <>
// // // //             {!isCollapsed && <div className="menu-section-label">User Management</div>}
// // // //             <div className="menu-group">
// // // //               <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle></svg></span>
// // // //                 {!isCollapsed && <span className="menu-text">User</span>}
// // // //               </div>
// // // //               <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // // //                 {!isCollapsed && <span className="menu-text">Student</span>}
// // // //               </div>
// // // //               <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
// // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
// // // //                 {!isCollapsed && <span className="menu-text">Teacher</span>}
// // // //               </div>
// // // //               <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // // //                 {!isCollapsed && <span className="menu-text">Sponsors</span>}
// // // //               </div>
// // // //               <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // // //                 {!isCollapsed && <span className="menu-text">School Information</span>}
// // // //               </div>
// // // //             </div>
// // // //           </>
// // // //         )}

// // // //         {isTeacher && (
// // // //           <div className="menu-group">
// // // //             <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path></svg></span>
// // // //               {!isCollapsed && <span className="menu-text">Student List</span>}
// // // //             </div>
// // // //           </div>
// // // //         )}

// // // //         <div className="menu-group bottom-group">
// // // //           <div title="User Profile" className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09"></path></svg></span>
// // // //             {!isCollapsed && <span className="menu-text">{isSuperAdmin ? 'Settings' : 'User Profile'}</span>}
// // // //           </div>

// // // //           <div className={`sidebar-profile ${isCollapsed ? 'centered' : ''}`} onClick={() => handleNavigation('/settings')} title="View Profile">
// // // //             <img 
// // // //               src={userProfile.avatar} 
// // // //               alt="Profile" 
// // // //               className="sidebar-profile-img" 
// // // //               onError={(e) => { e.target.src = 'https://ui-avatars.com/api/?name=User&background=1559C3&color=fff'; }}
// // // //             />
// // // //             {!isCollapsed && (
// // // //               <div className="sidebar-profile-info">
// // // //                 <span className="sidebar-profile-name">{userProfile.name}</span>
// // // //                 <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // // //               </div>
// // // //             )}
// // // //           </div>

// // // //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// // // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // // //             {!isCollapsed && <span className="menu-text">Log out</span>}
// // // //           </div>
// // // //         </div>
// // // //       </div>
// // // //     </aside>
// // // //   );
// // // // };

// // // // export default Sidebar;



// // // import React, { useState, useEffect } from 'react';
// // // import { useNavigate, useLocation } from 'react-router-dom';
// // // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // // import './Sidebar.css';
// // // import logo from '../../assets/trustchildlogo.png';

// // // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// // //   const navigate = useNavigate();
// // //   const location = useLocation();

// // //   const [userProfile, setUserProfile] = useState({
// // //     name: 'Loading...',
// // //     role: '',
// // //     avatar: null
// // //   });

// // //   useEffect(() => {
// // //     const loadData = async () => {
// // //       const decoded = getDecodedToken();
// // //       if (!decoded || !decoded.userId) {
// // //         navigate('/login');
// // //         return;
// // //       }

// // //       try {
// // //         // Fetch fresh user details from the backend
// // //         const response = await apiFetch(`/users/${decoded.userId}`);

// // //         if (response.ok) {
// // //           const data = await response.json();
// // //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// // //           // Construct the full URL for the profile photo
// // //           let photo = null;
// // //           if (data.photo_url) {
// // //             photo = data.photo_url.startsWith('http') 
// // //               ? data.photo_url 
// // //               : `http://localhost:3005${data.photo_url}`;
// // //           } else {
// // //             // Fallback: Generate a UI Avatar
// // //             photo = `https://ui-avatars.com/api/?name=${encodeURIComponent(fullName || 'User')}&background=1559C3&color=fff&bold=true`;
// // //           }

// // //           setUserProfile({
// // //             name: fullName || 'User',
// // //             role: data.role || decoded.role,
// // //             avatar: photo
// // //           });
// // //         }
// // //       } catch (error) {
// // //         console.error("Sidebar profile fetch error:", error);
// // //       }
// // //     };

// // //     loadData();
// // //     // REMOVED location.pathname from dependencies to prevent reloading on menu click
// // //   }, [navigate]); 

// // //   const handleLogout = () => {
// // //     removeToken();
// // //     navigate('/login');
// // //   };

// // //   const isActive = (path) => location.pathname === path;

// // //   const role = userProfile.role ? userProfile.role.toLowerCase() : '';
// // //   const isSuperAdmin = role === 'super_admin';
// // //   const isTeacher = role === 'teacher';
// // //   const isStudent = role === 'student';

// // //   return (
// // //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// // //       <div className="sidebar-header">
// // //         <div className="logo-container">
// // //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// // //           {!isCollapsed && <span className="sidebar-logo-text">Trust Children</span>}
// // //         </div>
// // //       </div>

// // //       <div className="sidebar-menu">
// // //         <div className="menu-group">
// // //           {/* Dashboard: Visible to ALL */}
// // //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></span>
// // //             {!isCollapsed && <span className="menu-text">Dashboard</span>}
// // //           </div>

// // //           {/* Super Admin Specific Items */}
// // //           {isSuperAdmin && (
// // //             <>
// // //               <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg></span>
// // //                 {!isCollapsed && <span className="menu-text">Apps Analytics</span>}
// // //               </div>
// // //               <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></span>
// // //                 {!isCollapsed && <span className="menu-text">Manage App</span>}
// // //               </div>
// // //             </>
// // //           )}

// // //           {/* Teacher Specific Items */}
// // //           {isTeacher && (
// // //             <div title="Marks Entry" className={`menu-item ${isActive('/marks-entry') ? 'active' : ''}`} onClick={() => handleNavigation('/marks-entry')}>
// // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg></span>
// // //               {!isCollapsed && <span className="menu-text">Marks Entry</span>}
// // //             </div>
// // //           )}

// // //           {(isTeacher || isStudent) && (
// // //             <div title="Attendance" className={`menu-item ${isActive('/attendance') ? 'active' : ''}`} onClick={() => handleNavigation('/attendance')}>
// // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></span>
// // //               {!isCollapsed && <span className="menu-text">Attendance</span>}
// // //             </div>
// // //           )}

// // //           {isStudent && (
// // //             <div title="Report Card" className={`menu-item ${isActive('/report-card') ? 'active' : ''}`} onClick={() => handleNavigation('/report-card')}>
// // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></span>
// // //               {!isCollapsed && <span className="menu-text">Report Card</span>}
// // //             </div>
// // //           )}
// // //         </div>

// // //         {isSuperAdmin && (
// // //           <>
// // //             {!isCollapsed && <div className="menu-section-label">User Management</div>}
// // //             <div className="menu-group">
// // //               <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle></svg></span>
// // //                 {!isCollapsed && <span className="menu-text">User</span>}
// // //               </div>
// // //               <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
// // //                 {!isCollapsed && <span className="menu-text">Student</span>}
// // //               </div>
// // //               <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
// // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
// // //                 {!isCollapsed && <span className="menu-text">Teacher</span>}
// // //               </div>
// // //               <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg></span>
// // //                 {!isCollapsed && <span className="menu-text">Sponsors</span>}
// // //               </div>
// // //               <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// // //                 <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg></span>
// // //                 {!isCollapsed && <span className="menu-text">School Information</span>}
// // //               </div>
// // //             </div>
// // //           </>
// // //         )}

// // //         {isTeacher && (
// // //           <div className="menu-group">
// // //             <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// // //               <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path></svg></span>
// // //               {!isCollapsed && <span className="menu-text">Student List</span>}
// // //             </div>
// // //           </div>
// // //         )}

// // //         <div className="menu-group bottom-group">
// // //           <div title="User Profile" className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09"></path></svg></span>
// // //             {!isCollapsed && <span className="menu-text">{isSuperAdmin ? 'Settings' : 'User Profile'}</span>}
// // //           </div>

// // //           <div className={`sidebar-profile ${isCollapsed ? 'centered' : ''}`} onClick={() => handleNavigation('/settings')} title="View Profile">
// // //             <img 
// // //               src={userProfile.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile.name || 'User')}`} 
// // //               alt="Profile" 
// // //               className="sidebar-profile-img" 
// // //               onError={(e) => { e.target.src = 'https://ui-avatars.com/api/?name=User&background=1559C3&color=fff'; }}
// // //             />
// // //             {!isCollapsed && (
// // //               <div className="sidebar-profile-info">
// // //                 <span className="sidebar-profile-name">{userProfile.name}</span>
// // //                 <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// // //               </div>
// // //             )}
// // //           </div>

// // //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// // //             <span className="icon"><svg className="svg-icon" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
// // //             {!isCollapsed && <span className="menu-text">Log out</span>}
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </aside>
// // //   );
// // // };

// // // export default Sidebar;



// // import React, { useState, useEffect } from 'react';
// // import { useNavigate, useLocation } from 'react-router-dom';
// // import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// // import './Sidebar.css';
// // import logo from '../../assets/trustchildlogo.png';

// // const Sidebar = ({ isCollapsed, toggleCollapse }) => {
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   const [userProfile, setUserProfile] = useState({
// //     name: 'Loading...',
// //     role: '',
// //     avatar: null
// //   });

// //   useEffect(() => {
// //     const loadData = async () => {
// //       const decoded = getDecodedToken();
// //       if (!decoded || !decoded.userId) {
// //         navigate('/login');
// //         return;
// //       }

// //       try {
// //         const response = await apiFetch(`/users/${decoded.userId}`);

// //         if (response.ok) {
// //           const data = await response.json();
// //           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

// //           let photo = null;
// //           if (data.photo_url) {
// //             photo = data.photo_url.startsWith('http') 
// //               ? data.photo_url 
// //               : `http://localhost:3005${data.photo_url}`;
// //           } else {
// //             photo = `https://ui-avatars.com/api/?name=${encodeURIComponent(fullName || 'User')}&background=1559C3&color=fff&bold=true`;
// //           }

// //           setUserProfile({
// //             name: fullName || 'User',
// //             role: data.role || decoded.role,
// //             avatar: photo
// //           });
// //         }
// //       } catch (error) {
// //         console.error("Sidebar profile fetch error:", error);
// //       }
// //     };

// //     loadData();
// //   }, [navigate]);

// //   const handleLogout = () => {
// //     removeToken();
// //     navigate('/login');
// //   };

// //   const isActive = (path) => location.pathname === path;

// //   const role = userProfile.role ? userProfile.role.toLowerCase() : '';
// //   const isSuperAdmin = role === 'super_admin';
// //   const isTeacher = role === 'teacher';
// //   const isStudent = role === 'student';

// //   return (
// //     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
// //       {/* Expanded: White Header */}
// //       <div className="sidebar-header">
// //         <div className="logo-container">
// //           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
// //           <div className="logo-text-group">
// //             <span className="sidebar-logo-text">Trust Children</span>
// //           </div>
// //         </div>

// //         <button className="sidebar-toggle-btn" onClick={toggleCollapse}>
// //           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //             <path d="M15 18l-6-6 6-6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
// //           </svg>
// //         </button>
// //       </div>

// //       {/* Collapsed: Blue Header */}
// //       <div className="sidebar-collapsed-header">
// //         <div className="collapsed-logo-container">
// //           <img src={logo} alt="Trust Children Logo" className="collapsed-logo" />
// //         </div>

// //         <button className="collapsed-toggle-btn" onClick={toggleCollapse}>
// //           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //             <path d="M9 18l6-6-6-6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
// //           </svg>
// //         </button>
// //       </div>

// //       <div className="sidebar-menu">
// //         <div className="menu-group">
// //           {/* Dashboard */}
// //           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
// //             <span className="icon">
// //               <svg className="svg-icon" viewBox="0 0 24 24">
// //                 <rect x="3" y="3" width="7" height="7"></rect>
// //                 <rect x="14" y="3" width="7" height="7"></rect>
// //                 <rect x="14" y="14" width="7" height="7"></rect>
// //                 <rect x="3" y="14" width="7" height="7"></rect>
// //               </svg>
// //             </span>
// //             {!isCollapsed && <span className="menu-text">Dashboard</span>}
// //           </div>

// //           {/* Apps Analytics */}
// //           {isSuperAdmin && (
// //             <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
// //               <span className="icon">
// //                 <svg className="svg-icon" viewBox="0 0 24 24">
// //                   <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
// //                   <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
// //                 </svg>
// //               </span>
// //               {!isCollapsed && <span className="menu-text">Apps Analytics</span>}
// //             </div>
// //           )}

// //           {/* Manage App */}
// //           {isSuperAdmin && (
// //             <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
// //               <span className="icon">
// //                 <svg className="svg-icon" viewBox="0 0 24 24">
// //                   <circle cx="12" cy="12" r="3"></circle>
// //                   <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
// //                 </svg>
// //               </span>
// //               {!isCollapsed && <span className="menu-text">Manage App</span>}
// //             </div>
// //           )}

// //           {/* Marks Entry */}
// //           {isTeacher && (
// //             <div title="Marks Entry" className={`menu-item ${isActive('/marks-entry') ? 'active' : ''}`} onClick={() => handleNavigation('/marks-entry')}>
// //               <span className="icon">
// //                 <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// //                   <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
// //                   <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
// //                 </svg>
// //               </span>
// //               {!isCollapsed && <span className="menu-text">Marks Entry</span>}
// //             </div>
// //           )}

// //           {/* Attendance */}
// //           {(isTeacher || isStudent) && (
// //             <div title="Attendance" className={`menu-item ${isActive('/attendance') ? 'active' : ''}`} onClick={() => handleNavigation('/attendance')}>
// //               <span className="icon">
// //                 <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// //                   <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
// //                 </svg>
// //               </span>
// //               {!isCollapsed && <span className="menu-text">Attendance</span>}
// //             </div>
// //           )}

// //           {/* Report Card */}
// //           {isStudent && (
// //             <div title="Report Card" className={`menu-item ${isActive('/report-card') ? 'active' : ''}`} onClick={() => handleNavigation('/report-card')}>
// //               <span className="icon">
// //                 <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// //                   <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
// //                 </svg>
// //               </span>
// //               {!isCollapsed && <span className="menu-text">Report Card</span>}
// //             </div>
// //           )}
// //         </div>

// //         {/* USER MANAGEMENT Section */}
// //         {isSuperAdmin && (
// //           <>
// //             {!isCollapsed && <div className="menu-section-label">USER MANAGEMENT</div>}
// //             <div className="menu-group">
// //               <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
// //                 <span className="icon">
// //                   <svg className="svg-icon" viewBox="0 0 24 24">
// //                     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
// //                     <circle cx="9" cy="7" r="4"></circle>
// //                   </svg>
// //                 </span>
// //                 {!isCollapsed && <span className="menu-text">User</span>}
// //               </div>

// //               <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// //                 <span className="icon">
// //                   <svg className="svg-icon" viewBox="0 0 24 24">
// //                     <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
// //                     <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
// //                   </svg>
// //                 </span>
// //                 {!isCollapsed && <span className="menu-text">Student</span>}
// //               </div>

// //               <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
// //                 <span className="icon">
// //                   <svg className="svg-icon" viewBox="0 0 24 24">
// //                     <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
// //                     <circle cx="12" cy="7" r="4"></circle>
// //                   </svg>
// //                 </span>
// //                 {!isCollapsed && <span className="menu-text">Teacher</span>}
// //               </div>

// //               <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
// //                 <span className="icon">
// //                   <svg className="svg-icon" viewBox="0 0 24 24">
// //                     <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
// //                     <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
// //                   </svg>
// //                 </span>
// //                 {!isCollapsed && <span className="menu-text">Sponsors</span>}
// //               </div>

// //               <div title="School Information" className={`menu-item ${isActive('/school-information') ? 'active' : ''}`} onClick={() => handleNavigation('/school-information')}>
// //                 <span className="icon">
// //                   <svg className="svg-icon" viewBox="0 0 24 24">
// //                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
// //                     <polyline points="14 2 14 8 20 8"></polyline>
// //                   </svg>
// //                 </span>
// //                 {!isCollapsed && <span className="menu-text">School Information</span>}
// //               </div>
// //             </div>
// //           </>
// //         )}

// //         {/* Teacher Student List */}
// //         {isTeacher && (
// //           <div className="menu-group">
// //             <div title="Student List" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
// //               <span className="icon">
// //                 <svg className="svg-icon" viewBox="0 0 24 24">
// //                   <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
// //                 </svg>
// //               </span>
// //               {!isCollapsed && <span className="menu-text">Student List</span>}
// //             </div>
// //           </div>
// //         )}

// //         {/* Bottom Group */}
// //         <div className="menu-group bottom-group">
// //           <div title={isSuperAdmin ? 'Settings' : 'User Profile'} className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
// //             <span className="icon">
// //               <svg className="svg-icon" viewBox="0 0 24 24">
// //                 <circle cx="12" cy="12" r="3"></circle>
// //                 <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09"></path>
// //               </svg>
// //             </span>
// //             {!isCollapsed && <span className="menu-text">{isSuperAdmin ? 'Settings' : 'User Profile'}</span>}
// //           </div>

// //           <div className={`sidebar-profile ${isCollapsed ? 'centered' : ''}`} onClick={() => handleNavigation('/settings')} title="View Profile">
// //             <img 
// //               src={userProfile.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile.name || 'User')}`} 
// //               alt="Profile" 
// //               className="sidebar-profile-img" 
// //               onError={(e) => { e.target.src = 'https://ui-avatars.com/api/?name=User&background=1559C3&color=fff'; }}
// //             />
// //             {!isCollapsed && (
// //               <div className="sidebar-profile-info">
// //                 <span className="sidebar-profile-name">{userProfile.name}</span>
// //                 <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
// //               </div>
// //             )}
// //           </div>

// //           <div title="Log out" className="menu-item" onClick={handleLogout}>
// //             <span className="icon">
// //               <svg className="svg-icon" viewBox="0 0 24 24">
// //                 <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
// //                 <polyline points="16 17 21 12 16 7"></polyline>
// //                 <line x1="21" y1="12" x2="9" y2="12"></line>
// //               </svg>
// //             </span>
// //             {!isCollapsed && <span className="menu-text">Log out</span>}
// //           </div>
// //         </div>
// //       </div>
// //     </aside>
// //   );
// // };

// // export default Sidebar;


// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
// import './Sidebar.css';
// import logo from '../../assets/trustchildlogo.png';

// const Sidebar = ({ isCollapsed, toggleCollapse }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [userProfile, setUserProfile] = useState({
//     name: 'Loading...',
//     role: '',
//     avatar: null
//   });

//   useEffect(() => {
//     const loadData = async () => {
//       const decoded = getDecodedToken();
//       if (!decoded || !decoded.userId) {
//         navigate('/login');
//         return;
//       }

//       try {
//         const response = await apiFetch(`/users/${decoded.userId}`);

//         if (response.ok) {
//           const data = await response.json();
//           const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim();

//           let photo = null;
//           if (data.photo_url) {
//             photo = data.photo_url.startsWith('http')
//               ? data.photo_url
//               : `http://localhost:3005${data.photo_url}`;
//           } else {
//             photo = `https://ui-avatars.com/api/?name=${encodeURIComponent(fullName || 'User')}&background=1559C3&color=fff&bold=true`;
//           }

//           setUserProfile({
//             name: fullName || 'User',
//             role: data.role || decoded.role,
//             avatar: photo
//           });
//         }
//       } catch (error) {
//         console.error("Sidebar profile fetch error:", error);
//       }
//     };

//     loadData();
//   }, [navigate]);

//   const handleLogout = () => {
//     removeToken();
//     navigate('/login');
//   };

//   const isActive = (path) => location.pathname === path;

//   const role = userProfile.role ? userProfile.role.toLowerCase() : '';
//   const isSuperAdmin = role === 'super_admin';
//   const isTeacher = role === 'teacher';
//   const isStudent = role === 'student';

//   return (
//     <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
//       {/* Expanded: White Header */}
//       <div className="sidebar-header">
//         <div className="logo-container">
//           <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
//           <div className="logo-text-group">
//             <span className="sidebar-logo-text">Trust Children</span>
//           </div>
//         </div>

//         <button className="sidebar-toggle-btn" onClick={toggleCollapse}>
//           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//             <path d="M15 18l-6-6 6-6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
//           </svg>
//         </button>
//       </div>

//       {/* Collapsed: Blue Header */}
//       <div className="sidebar-collapsed-header">
//         <div className="collapsed-logo-container">
//           <img src={logo} alt="Trust Children Logo" className="collapsed-logo" />
//         </div>

//         <button className="collapsed-toggle-btn" onClick={toggleCollapse}>
//           <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//             <path d="M9 18l6-6-6-6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
//           </svg>
//         </button>
//       </div>

//       <div className="sidebar-menu">
//         <div className="menu-group">
//           {/* Dashboard */}
//           <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
//             <span className="icon">
//               <svg className="svg-icon" viewBox="0 0 24 24">
//                 <rect x="3" y="3" width="7" height="7"></rect>
//                 <rect x="14" y="3" width="7" height="7"></rect>
//                 <rect x="14" y="14" width="7" height="7"></rect>
//                 <rect x="3" y="14" width="7" height="7"></rect>
//               </svg>
//             </span>
//             {!isCollapsed && <span className="menu-text">Dashboard</span>}
//           </div>

//           {/* Apps Analytics */}
//           {isSuperAdmin && (
//             <div title="Apps Analytics" className={`menu-item ${isActive('/analytics') ? 'active' : ''}`} onClick={() => handleNavigation('/analytics')}>
//               <span className="icon">
//                 <svg className="svg-icon" viewBox="0 0 24 24">
//                   <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
//                   <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
//                 </svg>
//               </span>
//               {!isCollapsed && <span className="menu-text">Apps Analytics</span>}
//             </div>
//           )}

//           {/* Manage App */}
//           {isSuperAdmin && (
//             <div title="Manage App" className={`menu-item ${isActive('/manage-app') ? 'active' : ''}`} onClick={() => handleNavigation('/manage-app')}>
//               <span className="icon">
//                 <svg className="svg-icon" viewBox="0 0 24 24">
//                   <circle cx="12" cy="12" r="3"></circle>
//                   <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
//                 </svg>
//               </span>
//               {!isCollapsed && <span className="menu-text">Manage App</span>}
//             </div>
//           )}

//           {/* Marks Entry */}
//           {isTeacher && (
//             <div title="Marks Entry" className={`menu-item ${isActive('/marks-entry') ? 'active' : ''}`} onClick={() => handleNavigation('/marks-entry')}>
//               <span className="icon">
//                 <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
//                   <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
//                 </svg>
//               </span>
//               {!isCollapsed && <span className="menu-text">Marks Entry</span>}
//             </div>
//           )}

//           {/* Attendance */}
//           {(isTeacher || isStudent) && (
//             <div title="Attendance" className={`menu-item ${isActive('/attendance') ? 'active' : ''}`} onClick={() => handleNavigation('/attendance')}>
//               <span className="icon">
//                 <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//                 </svg>
//               </span>
//               {!isCollapsed && <span className="menu-text">Attendance</span>}
//             </div>
//           )}

//           {/* Report Card */}
//           {isStudent && (
//             <div title="Report Card" className={`menu-item ${isActive('/report-card') ? 'active' : ''}`} onClick={() => handleNavigation('/report-card')}>
//               <span className="icon">
//                 <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
//                 </svg>
//               </span>
//               {!isCollapsed && <span className="menu-text">Report Card</span>}
//             </div>
//           )}
//         </div>

//         {/* USER MANAGEMENT Section */}
//         {isSuperAdmin && (
//           <>
//             {!isCollapsed && <div className="menu-section-label">USER MANAGEMENT</div>}
//             <div className="menu-group">
//               <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
//                 <span className="icon">
//                   <svg className="svg-icon" viewBox="0 0 24 24">
//                     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
//                     <circle cx="9" cy="7" r="4"></circle>
//                   </svg>
//                 </span>
//                 {!isCollapsed && <span className="menu-text">User</span>}
//               </div>

//               <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
//                 <span className="icon">
//                   <svg className="svg-icon" viewBox="0 0 24 24">
//                     <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
//                     <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
//                   </svg>
//                 </span>
//                 {!isCollapsed && <span className="menu-text">Student</span>}
//               </div>

//               <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
//                 <span className="icon">
//                   <svg className="svg-icon" viewBox="0 0 24 24">
//                     <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//                     <circle cx="12" cy="7" r="4"></circle>
//                   </svg>
//                 </span>
//                 {!isCollapsed && <span className="menu-text">Teacher</span>}
//               </div>

//               <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
//                 <span className="icon">
//                   <svg className="svg-icon" viewBox="0 0 24 24">
//                     <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
//                     <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
//                   </svg>
//                 </span>
//                 {!isCollapsed && <span className="menu-text">Sponsors</span>}
//               </div>

//               {/* UPDATED: School Configuration instead of Information */}
//               <div title="School Configuration" className={`menu-item ${isActive('/school-configuration') ? 'active' : ''}`} onClick={() => handleNavigation('/school-configuration')}>
//                 <span className="icon">
//                   <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.1a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
//                     <circle cx="12" cy="12" r="3"></circle>
//                   </svg>
//                 </span>
//                 {!isCollapsed && <span className="menu-text">School Configuration</span>}
//               </div>
//             </div>
//           </>
//         )}

//         {/* Teacher Student List */}
//         {isTeacher && (
//           <div className="menu-group">
//             <div title="Student List" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
//               <span className="icon">
//                 <svg className="svg-icon" viewBox="0 0 24 24">
//                   <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
//                 </svg>
//               </span>
//               {!isCollapsed && <span className="menu-text">Student List</span>}
//             </div>
//           </div>
//         )}

//         {/* Bottom Group */}
//         <div className="menu-group bottom-group">
//           <div title={isSuperAdmin ? 'Settings' : 'User Profile'} className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
//             <span className="icon">
//               <svg className="svg-icon" viewBox="0 0 24 24">
//                 <circle cx="12" cy="12" r="3"></circle>
//                 <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09"></path>
//               </svg>
//             </span>
//             {!isCollapsed && <span className="menu-text">{isSuperAdmin ? 'Settings' : 'User Profile'}</span>}
//           </div>

//           <div className={`sidebar-profile ${isCollapsed ? 'centered' : ''}`} onClick={() => handleNavigation('/settings')} title="View Profile">
//             <img
//               src={userProfile.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile.name || 'User')}`}
//               alt="Profile"
//               className="sidebar-profile-img"
//               onError={(e) => { e.target.src = 'https://ui-avatars.com/api/?name=User&background=1559C3&color=fff'; }}
//             />
//             {!isCollapsed && (
//               <div className="sidebar-profile-info">
//                 <span className="sidebar-profile-name">{userProfile.name}</span>
//                 <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
//               </div>
//             )}
//           </div>

//           <div title="Log out" className="menu-item" onClick={handleLogout}>
//             <span className="icon">
//               <svg className="svg-icon" viewBox="0 0 24 24">
//                 <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
//                 <polyline points="16 17 21 12 16 7"></polyline>
//                 <line x1="21" y1="12" x2="9" y2="12"></line>
//               </svg>
//             </span>
//             {!isCollapsed && <span className="menu-text">Log out</span>}
//           </div>
//         </div>
//       </div>
//     </aside>
//   );
// };

// export default Sidebar;



import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { removeToken, getDecodedToken, apiFetch } from '../../utils/auth';
import { useUser } from '../../context/UserContext';
import './Sidebar.css';
import logo from '../../assets/trustchildlogo.png';

const Sidebar = ({ isCollapsed, toggleCollapse, isMobileOpen, closeMobileSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { currentUser, logout } = useUser();

  const [userProfile, setUserProfile] = useState({
    name: 'Loading...',
    role: '',
    avatar: null
  });

  useEffect(() => {
    if (currentUser) {
      const fullName = `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim();

      let photo = null;
      if (currentUser.photo_url) {
        photo = currentUser.photo_url.startsWith('http')
          ? currentUser.photo_url
          : `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:3005'}${currentUser.photo_url}`;
      } else {
        photo = `https://ui-avatars.com/api/?name=${encodeURIComponent(fullName || 'User')}&background=1559C3&color=fff&bold=true`;
      }

      setUserProfile({
        name: fullName || 'User',
        role: currentUser.role || '',
        avatar: photo
      });
    }
  }, [currentUser]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Helper to navigate and close mobile sidebar
  const handleNavigation = (path) => {
    navigate(path);
    if (closeMobileSidebar) {
      closeMobileSidebar();
    }
  };

  const isActive = (path) => location.pathname === path;

  const role = userProfile.role ? userProfile.role.toLowerCase() : '';
  const isSuperAdmin = role === 'super_admin';
  const isPrincipal = role === 'principal';
  const isTeacher = role === 'teacher';
  const isStudent = role === 'student';

  // Principal gets everything Super Admin gets
  const isAdmin = role === 'admin';
  const hasAdminPrivileges = isSuperAdmin || isPrincipal || isAdmin;

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
      {/* Expanded: White Header */}
      <div className="sidebar-header">
        <div className="logo-container">
          <img src={logo} alt="Trust Children Logo" className="sidebar-logo" />
          <div className="logo-text-group">
            <span className="sidebar-logo-text">Trust Children</span>
          </div>
        </div>

        <button className="sidebar-toggle-btn" onClick={toggleCollapse}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M15 18l-6-6 6-6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>

      {/* Collapsed: Blue Header */}
      <div className="sidebar-collapsed-header">
        <div className="collapsed-logo-container">
          <img src={logo} alt="Trust Children Logo" className="collapsed-logo" />
        </div>

        <button className="collapsed-toggle-btn" onClick={toggleCollapse}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M9 18l6-6-6-6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>

      <div className="sidebar-menu">
        <div className="menu-group">
          {/* Dashboard */}
          <div title="Dashboard" className={`menu-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
            <span className="icon">
              <svg className="svg-icon" viewBox="0 0 24 24">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </span>
            {!isCollapsed && <span className="menu-text">Dashboard</span>}
          </div>

          {/* Marks Management - Principal / Super Admin / Admin */}
          {hasAdminPrivileges && (
            <div title="Marks Management" className={`menu-item ${isActive('/marks-management') ? 'active' : ''}`} onClick={() => handleNavigation('/marks-management')}>
              <span className="icon">
                <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  <line x1="9" y1="11" x2="15" y2="11"></line>
                  <line x1="12" y1="8" x2="12" y2="14"></line>
                </svg>
              </span>
              {!isCollapsed && <span className="menu-text">Marks Management</span>}
            </div>
          )}

          {/* Marks Approval - Principal / Super Admin / Admin */}
          {hasAdminPrivileges && (
            <div title="Marks Approval" className={`menu-item ${isActive('/approvals') ? 'active' : ''}`} onClick={() => handleNavigation('/approvals')}>
              <span className="icon">
                <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 11l3 3L22 4"></path>
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                </svg>
              </span>
              {!isCollapsed && <span className="menu-text">Marks Approval</span>}
            </div>
          )}

          {/* Report Cards - Admin, Principal, Teacher */}
          {(hasAdminPrivileges || isTeacher) && (
            <div title="Report Cards" className={`menu-item ${isActive('/report-cards') ? 'active' : ''}`} onClick={() => handleNavigation('/report-cards')}>
              <span className="icon">
                <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
              </span>
              {!isCollapsed && <span className="menu-text">Report Cards</span>}
            </div>
          )}

          {/* Marks Entry */}
          {isTeacher && (
            <>
              <div title="Marks Entry" className={`menu-item ${isActive('/marks-entry') ? 'active' : ''}`} onClick={() => handleNavigation('/marks-entry')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">Marks Entry</span>}
              </div>

              <div title="Marks Corrections" className={`menu-item ${isActive('/corrections') ? 'active' : ''}`} onClick={() => handleNavigation('/corrections')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="12" y1="18" x2="12" y2="12"></line>
                    <line x1="9" y1="15" x2="15" y2="15"></line>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">Corrections</span>}
              </div>
            </>
          )}

          {/* Attendance Entry */}
          {(isTeacher || hasAdminPrivileges) && (
            <div title="Attendance Entry" className={`menu-item ${isActive('/attendance-entry') ? 'active' : ''}`} onClick={() => handleNavigation('/attendance-entry')}>
              <span className="icon">
                <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </span>
              {!isCollapsed && <span className="menu-text">Attendance Entry</span>}
            </div>
          )}

          {(isTeacher || hasAdminPrivileges) && (
            <div title="Attendance Reports" className={`menu-item ${isActive('/attendance-reports') ? 'active' : ''}`} onClick={() => handleNavigation('/attendance-reports')}>
              <span className="icon">
                <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
              </span>
              {!isCollapsed && <span className="menu-text">Attendance Reports</span>}
            </div>
          )}

          {/* Student Portal Navigation */}
          {isStudent && (
            <>
              <div title="My Profile" className={`menu-item ${isActive('/student/profile') ? 'active' : ''}`} onClick={() => handleNavigation('/student/profile')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">My Profile</span>}
              </div>

              <div title="My Attendance" className={`menu-item ${isActive('/student/attendance') ? 'active' : ''}`} onClick={() => handleNavigation('/student/attendance')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">My Attendance</span>}
              </div>

              <div title="My Report Cards" className={`menu-item ${isActive('/student/report-cards') ? 'active' : ''}`} onClick={() => handleNavigation('/student/report-cards')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">My Report Cards</span>}
              </div>
            </>
          )}
        </div>

        {/* USER MANAGEMENT Section */}
        {hasAdminPrivileges && (
          <>
            {!isCollapsed && <div className="menu-section-label">USER MANAGEMENT</div>}
            <div className="menu-group">
              <div title="User" className={`menu-item ${isActive('/user-management') ? 'active' : ''}`} onClick={() => handleNavigation('/user-management')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">User</span>}
              </div>

              <div title="Student" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24">
                    <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                    <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">Student</span>}
              </div>


              <div title="Teacher" className={`menu-item ${isActive('/teachers') ? 'active' : ''}`} onClick={() => handleNavigation('/teachers')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">Teacher</span>}
              </div>

              <div title="Sponsors" className={`menu-item ${isActive('/sponsors') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsors')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">Sponsors</span>}
              </div>

              <div title="TC Sync" className={`menu-item ${isActive('/pending-sponsorships') ? 'active' : ''}`} onClick={() => handleNavigation('/pending-sponsorships')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">TC Sync</span>}
              </div>

              <div title="School Configuration" className={`menu-item ${isActive('/school-configuration') ? 'active' : ''}`} onClick={() => handleNavigation('/school-configuration')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.1a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">School Configuration</span>}
              </div>

              <div title="Sponsorship Amounts" className={`menu-item ${isActive('/sponsorship-amounts') ? 'active' : ''}`} onClick={() => handleNavigation('/sponsorship-amounts')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">Sponsorship Amounts</span>}
              </div>

              <div title="Universal Import" className={`menu-item ${isActive('/manual-import') ? 'active' : ''}`} onClick={() => handleNavigation('/manual-import')}>
                <span className="icon">
                  <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="17 8 12 3 7 8"></polyline>
                    <line x1="12" y1="3" x2="12" y2="15"></line>
                  </svg>
                </span>
                {!isCollapsed && <span className="menu-text">Universal Import</span>}
              </div>

            </div>
          </>
        )}

        {/* Teacher Student List */}
        {isTeacher && (
          <div className="menu-group">
            <div title="Student List" className={`menu-item ${isActive('/students') ? 'active' : ''}`} onClick={() => handleNavigation('/students')}>
              <span className="icon">
                <svg className="svg-icon" viewBox="0 0 24 24">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                </svg>
              </span>
              {!isCollapsed && <span className="menu-text">Student List</span>}
            </div>
          </div>
        )}

        {/* Bottom Group */}
        <div className="menu-group bottom-group">
          <div title={hasAdminPrivileges ? 'Settings' : 'User Profile'} className={`menu-item ${isActive('/settings') ? 'active' : ''}`} onClick={() => handleNavigation('/settings')}>
            <span className="icon">
              <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
            </span>
            {!isCollapsed && <span className="menu-text">{hasAdminPrivileges ? 'Settings' : 'User Profile'}</span>}
          </div>

          <div className={`sidebar-profile ${isCollapsed ? 'centered' : ''}`} onClick={() => handleNavigation('/settings')} title="View Profile">
            <img
              src={userProfile.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile.name || 'User')}`}
              alt="Profile"
              className="sidebar-profile-img"
              onError={(e) => { e.target.src = 'https://ui-avatars.com/api/?name=User&background=1559C3&color=fff'; }}
            />
            {!isCollapsed && (
              <div className="sidebar-profile-info">
                <span className="sidebar-profile-name">{userProfile.name}</span>
                <span className="sidebar-profile-role">{userProfile.role.replace(/_/g, ' ')}</span>
              </div>
            )}
          </div>

          <div title="Log out" className="menu-item" onClick={handleLogout}>
            <span className="icon">
              <svg className="svg-icon" viewBox="0 0 24 24">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </span>
            {!isCollapsed && <span className="menu-text">Log out</span>}
          </div>
        </div>
      </div>
    </aside >
  );
};

export default Sidebar;
